import { createTheme } from '@mui/material';

import { breakpoints } from './breakpoints';
import { components } from './components';
import { typography } from './typography';
import { palette } from './palette';

export const theme = createTheme({
  palette,
  typography,
  components,
  breakpoints,
});
